import * as React from 'react';
import { useMemo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setUser } from '../../store/loginUserSlice';
import { Paper, Typography } from '@mui/material';
import Log from '../../lib/log';
import { useSelector } from '../../store/store';
import { setServiceNumber } from '../../store/setupUserSlice';
import upgradeUser from '../../functions/UpgradeUser';
import Spinner from '../atoms/Spinner';
import { useNavigate } from 'react-router-dom';
import { v2api } from '../../api/axios';

// ログの初期化
const log = new Log('SetupTransfer');

interface Props {
  valid: (value: boolean) => void;
}
export default function SetupTransfer(props: Props) {
  log.putLog('info', 'SetupTransfer started.');
  const [isValid, setIsValid] = useState(false);
  const [setupUser] = useState(useSelector((state) => state.setupUser));
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Spinner
  const [loading, setLoading] = useState(true);

  useMemo(async () => {
    console.log(`🐞 useMemo`);
    try {
      if (!isValid) {
        const serviceNumber = await upgradeUser(setupUser);
        dispatch(setServiceNumber(serviceNumber));
        setIsValid(true);
      }
      setLoading(false);
      const postData = {
        userId: setupUser.id,
        token: setupUser.token,
      };
      const res = await v2api.post('/get-user', postData);
      if (res.data.statusCode !== 200) {
        throw new Error('Can not get users.');
      }
      const user = JSON.parse(res.data.body);
      dispatch(setUser(user));
    } catch (err: any) {
      alert(err.message);
      navigate('/');
    }
  }, [setupUser, navigate, dispatch, isValid]);

  useEffect(() => {
    props.valid(isValid);
  }, [props, isValid]);

  if (loading) {
    return (
      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          height: 'auto',
        }}
      >
        <Typography variant='h6' gutterBottom component='div' color={'gray'}>
          現在、初期セットアップ行っています。この処理には1分程度かかります。
        </Typography>
        <Spinner loading={loading} />
      </Paper>
    );
  } else {
    return (
      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          height: 'auto',
        }}
      >
        <Typography variant='h6' gutterBottom component='div' color={'gray'}>
          初期セットアップが無事に終了しました。完了ボタンを押してください。
        </Typography>
      </Paper>
    );
  }
}
